import {Component, inject, ViewEncapsulation} from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '@core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { FeatherModule } from 'angular-feather';
import {User} from "@core/models/user";

@Component({
    selector: 'app-user-panel',
    templateUrl: './user-panel.component.html',
    styleUrls: ['./user-panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        MatButtonModule,
        RouterLink,
        MatTooltipModule,
        MatIconModule,
        TranslateModule,
        FeatherModule,
    ]
})
export class UserPanelComponent  {
  user!: User;

  private auth = inject(AuthService);

  constructor() { /* empty */ }

  logout() {
    this.auth.logout();
  }
}
